import { UrlMatcher, UrlSegment } from '@angular/router';

/**
 * @description 
 *  - Custom URL matcher to identify and redirect old 'water-safety' routes to new 'water-safety-iq' routes.
 *  - This matcher checks if the first segment of the URL is 'water-safety'.
 *  - If a match is found, it triggers the wsiRedirectGuard to handle the redirection.
 * 
 * @param url 
 *  - The array of URL segments to be matched. 
 * @returns 
 *  - An object with the consumed URL segments if a match is found, otherwise undefined.
 */

export const wsiRedirectMatcher: UrlMatcher = (url: UrlSegment[]) => {
  if (url?.length && url[0]?.path === 'water-safety') {
    return { consumed: url };
  }
};